var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.vrm)?_c('span',{staticClass:"tag is-vrm has-shadow is-medium has-text-weight-semibold",class:_vm.size},[_vm._v(" "+_vm._s(_vm.vrm)+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }